module.exports = __webpack_public_path__ + "img/page4-card-bg.a3af89af.jpg";